export default function doOnce(callback) {
  let done = false;
  return (...params) => {
    if (done) return null;
    done = true;
    return callback(...params);
  };
}
